<template>
  <div  class="download-box">
    <a-spin :tip="`附件导出中，请不要关闭浏览器${progress ? progress + '% ': ''}`" :spinning="loading">
      <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
    </a-spin>
    <!-- <a-spin size="large" />
    <div class="tips">附件导出中，请不要关闭浏览器 {{ progress }}</div> -->
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import axios from "axios";
import services from '../../../assets/js/services';
export default {
  name: "downLoad",
  components: {
  },
  data () {
    return {
      loading: false,
      school_code: localStorage.getItem("schoolCode"),
      activity_id: "",
      task_id: '',
      unique: '',
      backurl: '',
      progress: 0,
    };
  },
  computed: {
    ...mapState({
      activityInfo: (state) => state.activityStat.activityInfo,
    }),
  },
  mounted () {
    this.activity_id = this.$route.query.id
    this.task_id = this.$route.query.tid
    this.backurl = this.$route.query.url
    if (this.$route.query.unique && this.task_id) {
      this.loading = true
      this.unique = this.$route.query.unique
      this.getAttachStatus()
    }
  },
  methods: {
    ...mapActions(["getSchoolTaskDownAttach"]),
    // 导出附件
    exportAttach () {
      let that = this
      axios({
        url: services.HOST + `/api/school/train/work/${this.task_id}/download_attach?unique=${that.unique}` ,
        params: {},
        method: 'get',
        responseType: 'arraybuffer',
        onDownloadProgress: (progressEvent) => {
          if (progressEvent.lengthComputable) {
            that.progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
          }
        },
      }).then(res => {
        if (res && res.data) {
          that.loading = false
          let newUrl = window.URL.createObjectURL(new Blob([res.data]));
          let type = 'zip'
          let task_name = this.task_id == 't005' ? '绘云馆图谱实践作业' : this.task_id == 't006' ? '传点位打卡实践作业' : '创实践微影实践作业'
          that.createUrlBlob(newUrl, `【${(that.activityInfo && that.activityInfo.name) || ''}】【${task_name}】`, type)
          that.$router.push({
            path: `/${this.school_code}/school/activity/${that.backurl ? that.backurl : 'manage'}`,
            query: {
              id: that.activity_id,
            }
          })
        }
      }).catch(err => {
        that.loading = true
        console.log(err)
      })

    },
    // 先获取下载文件是否已生成
    getAttachStatus(){
      let that = this
      axios({
        url: services.HOST + `/api/school/train/work/${this.task_id}/download_attach?unique=${that.unique}&format=json` ,
        params: {},
        method: 'get',
        responseType: 'json',
      }).then(res => {
        if (res && res.data &&  res.data.code == '0000') {
          clearInterval(this.inter)
          that.exportAttach()
        } else {
          that.inter = setTimeout(() => {
            that.getAttachStatus()
          }, 2000);
        }
      }).catch(err => {
        that.loading = true
        console.log(err)
      })
    },
    // 文件流处理
    createUrlBlob (url, fileName, type) {
      const a = document.createElement('a')
      a.style.display = 'none'
      a.href = url
      a.setAttribute('download', `${fileName}.${type}`);
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    },
  },
   beforeDestroy () {
    clearInterval(this.inter)
  },
};
</script>

<style lang="less" scoped>
.download-box {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 99999;
    background-color: #fff;
}
.tips {
    color: #515861;
    font-size: 15px;
    margin: 20px auto;
    width: 100%;
    text-align: center;
    position: absolute;
    top: 55%;
    left: 50%;
    transform: translate(-50%);
}
</style>
